import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import {
  stringSplitFilter
} from './assets/js/filters'
import VueBus from './assets/js/vue-bus' // 组件传值
import VueClipboard from 'vue-clipboard2' // 复制粘贴
import VueCookies from 'vue-cookies' // 浏览存储
import VueLazyload from 'vue-lazyload' // 图片懒加载
import vConsole from 'vconsole' // 移动端打印
import './assets/js/rem' // 移动端适配
import md5 from 'js-md5'
import 'swiper/css/swiper.css'
// import '../src/assets/css/wap_vant.css'
import '@vant/touch-emulator';
import qs from 'qs'
Vue.prototype.$md5 = md5;
// vant框架组件的使用
import {
  Dialog,
  Button,
  Search,
  Icon,
  Swipe,
  SwipeItem,
  NoticeBar,
  Tab,
  Tabs,
  NavBar,
  Rate,
  Pagination,
  Toast,
  Tabbar,
  TabbarItem,
  Popup,
  List,
  Overlay,
  Uploader,
  Switch,
  Loading,
} from 'vant';
Vue.use(Button).use(Tab).use(Tabs)
  .use(Search).use(Icon).use(NoticeBar).use(NavBar)
  .use(Rate).use(Pagination).use(Toast)
  .use(Tabbar).use(TabbarItem).use(Dialog)
  .use(Popup).use(List).use(Overlay).use(Uploader)
  .use(Switch).use(Loading);
// 个别库和插件的使用
Vue.use(VueBus);
Vue.use(VueClipboard);
Vue.use(VueCookies);
Vue.use(VueLazyload);
Vue.filter('stringSplitFilter', stringSplitFilter);

// Vue.prototype.$vConsole = new vConsole()
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

// 百度统计
let host = window.location.host;
if (host == "m.gamehl.com") {
  console.log('gamehl', host);
  var _hmt = _hmt || [];
  (function () {
    var hm = document.createElement("script");
    hm.src = "https://hm.baidu.com/hm.js?4c8cc03a69eb00841ef10732e5e8968c";
    var s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(hm, s);
  })();
} else {
  console.log('dingdangyou', host);
  var _hmt = _hmt || [];
  (function () {
    var hm = document.createElement("script");
    hm.src = "https://hm.baidu.com/hm.js?b5ccb11332490d14d9189833d3ebdf14";
    var s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(hm, s);
  })();
}